import React, { useEffect } from "react";
import { useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Blacknavtop from "../../../components/Navbar/Blacknavtop";
import Axios from "axios";
import { apiURL } from "../../../keys.js";
import Footer from "../../../components/footer/main";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import BlogHomeCard from "../../../components/Cards/blogcard";
import SmallTopicList from "../../../components/topiclist/smalltopiclist";

const Category = (props) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Axios.get(`${apiURL}/blogs/category/${props.match.params.cats.toLowerCase()}`).then((data) => {
      console.log(data);
      setBlogs(data.data.data);
      setLoading(false);
    });
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="bg_smoke">
      <Blacknavtop />
      <Navbar />
      <br />

      <div className="container mt_7rem mb_6rem">
        <Link to="/">
          <button type="button" class="btn btn-outline-secondary  mb_10px">
            Back
          </button>
        </Link>
        <SmallTopicList />
        <br />
        <h3 className="tgrey">
          CATEGORY : <span className="tblue">{props.match.params.cats}</span>
        </h3>
        <br />
        {loading && blogs.length == 0 ? (
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        ) : (
          <>
            {console.log(blogs)}
            {blogs.map((blogs, id) => (
              <BlogHomeCard key={id} blog={blogs} />
            ))}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Category;
